export default class SkipNavigationPlugin {
  opt: any;
  dom: HTMLElement;

  constructor(dom: HTMLElement, o: any) {
    const defaults = {};

    this.opt = {
      ...defaults,
      ...o,
    };

    this.dom = dom;
  }

  init() {
    this.changeFocus();
  }

  changeFocus() {
    this.dom.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const targetElement = document.querySelector<HTMLElement>('.js-content');
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

          targetElement.setAttribute('tabindex', '-1');
          targetElement.focus();

          const firstChildElement = targetElement.firstElementChild as HTMLElement;

          if (firstChildElement) {
            firstChildElement.focus();
          }
        }
      }
    });
  }

  detach() {}
}
